module.exports = __webpack_public_path__ + "static/media/microsoft-3-code.3067665e.png";